export const AIR_TIME_FAIRNESS_SECTION_EVENT =
	'canvas-agent:air-time-fairness:section';
export const AIR_TIME_FAIRNESS_FOCUS_EVENT =
	'canvas-agent:air-time-fairness:focus';
export const AIR_TIME_FAIRNESS_EDIT_MODAL_EVENT =
	'canvas-agent:air-time-fairness:edit-modal';
